import { Wrapper, Image } from './Styled'

export default function Loading() {
  return (
    <Wrapper>
      <Image />
    </Wrapper>
  )
}
